import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import WarningIcon from "@mui/icons-material/Warning";
import { Stack, TextField, Typography } from "@material-ui/core";
import { Icon } from "@iconify/react";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { useSnackbar } from "notistack5";
import ColorSinglePicker from "../../../ColorSinglePicker";
import { useState, useEffect } from "react";
import apiContact from "../../../../api/contact";
import { objectID } from "../../../../utils/objectID";
import ColorTagMultiPicker from "../../../ColorTagMultiPicker";
import apiUser from "../../../../api/user";
const Item = styled(Paper)(({ theme }) => ({
  direction: "row",
  display: "flex",
  spacing: "10px",
  padding: "5px",
  justifyContent: "center",
  cursor: "pointer",
}));
const ListItem = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const COLOR_OPTIONS = [
  { color: "#FF4842", tag: "VIP" },
  { color: "#3BEF37", tag: "Mới" },
  { color: "#1890FF", tag: "Quan Tâm" },
  { color: "#FFC107", tag: "Thường" },
  { color: "#04297A", tag: "Đã Chốt" },
];
const COLOR_OPTIONS_MORE = [
  "#00AB55", // theme.palette.primary.main,
  "#1890FF", // theme.palette.info.main,
  "#94D82D", // theme.palette.success.main,
  "#FFC107", // theme.palette.warning.main,
  "#FF4842", // theme.palette.error.main
  "#04297A", // theme.palette.info.darker
  "#7A0C2E", // theme.palette.error.darker
];
export default function AlertFormTag({
  open,
  onClose,
  infoTagSelected,
  loadListContact,
  loadFieldContact,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [addTags, setAddTags] = useState(false);
  const [infoTag, setInfoTag] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [errorAddTag, setErrorAddTag] = useState(false);
  const [messageErrorAddTag, setMessageErrorAddTag] = useState('');
  const [chooseColor, setChooseColor] = useState('');
  const [chooseTag, setChooseTag] = useState('');

  const findTags = async () => {
    try {
      const res = await apiUser.find_tags();
      if (res.status === 200) {
        setColorOptions(res?.data?.data);
      } else {
        // setColorOptions(COLOR_OPTIONS);
        enqueueSnackbar(
          "Không tìm thấy danh sách nhãn, vui lòng tạo nhãn !",
          { variant: "error" }
        );
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar(
        "Không tìm thấy danh sách nhãn, vui lòng tạo nhãn !",
        { variant: "error" }
      );
      // setColorOptions(COLOR_OPTIONS);
    }
  };
  useEffect(() => {
    findTags();
  }, []);
  const handleChooseTag = (e) => {
    setSelectedColors(e);
    if (e.length > 0) {
      setInfoTag(e);
    }
  };
  const handleAddTags = () => {
    setAddTags(!addTags);
    setInfoTag([]);
  };
  // const onHandleChangeTag = (e) => {
  //   // setInfoTag({ ...infoTag, tag: e.target.value });
  // };
  // const onHandleChangeColorTag = (e) => {
  //   // setInfoTag({ ...infoTag, color: e.target.value });
  // };

  const handleAddTag = async () => {
    if (chooseColor === "" || chooseTag === "") {
      setErrorAddTag(true);
      setMessageErrorAddTag("Bạn chưa chọn màu hoặc nhập tên nhãn !!!");
      return;
    }
    if (chooseTag.length > 20) {
      setErrorAddTag(true);
      setMessageErrorAddTag("Tên nhãn không quá 20 ký tự !!!");
      return;
    }
    try {
      const insertTag = await apiUser.insert_tags({
        tag: chooseTag,
        color: chooseColor,
      });
      if (insertTag.status === 200) {
        setAddTags(false);
        findTags();
        enqueueSnackbar("Thêm nhãn thành công !", { variant: "success" });
      } else {
        enqueueSnackbar("Thêm nhãn thất bại, vui lòng thử lại !", {
          variant: "error",
        });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("Thêm nhãn thất bại, vui lòng thử lại !", {
        variant: "error",
      });
    }
    setErrorAddTag(false);
    setMessageErrorAddTag("");
  };

  const onUpdateContact = async () => {
    if (infoTag && infoTag.length > 0) {
      try {
        await apiContact.edit_tag({
          id: objectID(infoTagSelected._id),
          tags: infoTag,
        });
        loadListContact();
        loadFieldContact();
        enqueueSnackbar("Cập nhật thành công", { variant: "success" });
        onClose();
      } catch (error) {
        enqueueSnackbar(error.response.data.message[0], { variant: "error" });
      }
    } else {
      enqueueSnackbar("Vui lòng kiểm tra lại nhãn", { variant: "error" });
    }
  };
  return (
    <Dialog
      open={open}
      // onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={7000}
    >
      <DialogTitle id="alert-dialog-title">
        <Stack direction={"row"} spacing={1}>
          <WarningIcon color="warning" style={{ fontSize: "36px" }} />
          <Typography variant="h4"  >Danh sách nhãn</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <DialogContentText id="alert-dialog-description">
          {/* Người dùng của bạn đang sử dụng nhiều cuộc trò chuyện. Bạn có thể chọn cuộc trò chuyện!!! */}
        </DialogContentText>
        <DialogContentText id="alert-dialog-description">
          <Paper
            sx={{ p: 1, gap: 1, display: "flex", flexDirection: "column" }}
          >
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 3, sm: 2 }}
            >
              {!addTags ? (
                <ColorTagMultiPicker
                  onChange={(e) => handleChooseTag(e)}
                  selectedColors={selectedColors}
                  colors={colorOptions}
                />
              ) : null}
              <Button
                onClick={() => handleAddTags()}
                startIcon={
                  addTags ? (
                    <Icon icon="icon-park-outline:down-two" />
                  ) : (
                    <Icon icon="typcn:plus-outline" />
                  )
                }
                variant="outlined"
              >
                {addTags ? "Hủy thêm nhãn" : "Thêm nhãn"}
              </Button>
            </Stack>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={{ xs: 3, sm: 2 }}
            >
              {addTags ? (
                <>
                  <ColorSinglePicker
                    onChange={(e) => setChooseColor(e.target.value)}
                    colors={COLOR_OPTIONS_MORE}
                  />
                  <TextField
                    error={errorAddTag}
                    helperText={messageErrorAddTag}
                    onChange={(e) => setChooseTag(e.target.value)}
                    variant="standard"
                    label="Tên nhãn"
                  ></TextField>
                  <Button
                    onClick={(e) => handleAddTag(e)}
                    color="secondary"
                    variant="contained"
                    sx={{ ml: 1, height: "46px" }}
                  >
                    Thêm nhãn
                  </Button>
                </>
              ) : null}
            </Stack>
          </Paper>
        </DialogContentText>
      </DialogContent>
      {!addTags && 
        <DialogActions>
        <Button color="secondary" variant="contained" onClick={onClose}>
          Hủy bỏ
        </Button>
        <Button
          color="secondary"
          variant="contained"
          onClick={() => onUpdateContact()}
          autoFocus
        >
          Lưu
        </Button>
      </DialogActions>
      }
    </Dialog>
  );
}
